import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://hapwrcoabbackocyuksu.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhhcHdyY29hYmJhY2tvY3l1a3N1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg1OTYzMTYsImV4cCI6MjA1NDE3MjMxNn0.LNNQcCrb42x-2vHkfwxrvplR3HhbZaXsM8PN9yIgxyY'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
